import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { useStore } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { useScrollMemory } from '../../../../hooks/use-scroll-memory';
import { useSearchParams } from '../../../../hooks/use-search-params';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { UsersSvc } from '../../../../shared/services/users-service';
import { StatusCode } from '../../../../utils/api';
import { PageNames, Routes, ScrollStatePaths } from '../../../../utils/app-constants';
import * as userActions from '../../../../support/actions';
import { UserListRow } from '../components/UserListRow';
import { UserList } from '../../../../support/models/users/user-list';
import { UserSearchFilters } from '../../../../support/models/users/user-search-filters';
import { getUserSearchFilters } from '../../../../support/selectors';
import "../../../../support/styles.scss";

export const UsersScene = () => {
   
    const store = useStore();
    const [service] = React.useState(new UsersSvc());
    const [filterParams, setFilterParams] = React.useState(() => {
        return getUserSearchFilters(store.getState());
    });

    const [users, setUsers] = React.useState(() => {
         const initial = new PagedApiResult<UserList>();
         initial.pagination = filterParams.paginationInfo;
         initial.pagination.reusePaging = true;
         return initial;
    });

    const scrollTo = useScrollMemory(
        ScrollStatePaths.SUPPORT_USERS,
        Routes.SHIPPING_FLEET_DRIVERS_EDIT
    );
    
    useSearchParams(
        Routes.SUPPORT_USER_EDIT,
        userActions.updateUserSearchFilters(filterParams),
        userActions.clearUserSearch()
    );

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: UserSearchFilters) => {
        const response = await service.search(UserList, filters);
        if (response.status === StatusCode.Success) {
            setUsers(response.data);
            scrollTo();
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new UserSearchFilters();
        setFilterParams(tmp);
    };

    return <PageContent pageName={PageNames.SUPPORT_USERS_LIST}>
                    <PageHeading>                        
                        <HasPermission requiredPermissions={[
                            Permissions.SupportUsersCreate
                        ]}>
                            <NavLink className="btn new attention" to={Routes.SUPPORT_USER_EDIT}>Add User</NavLink>
                        </HasPermission>
                    </PageHeading>
                    <PageBody>
                        <PagedList
                            noResultsMessage="No users found, please search again."
                            searchCallback={ onSearch }
                            data={ users }
                            filterProps={ filterParams }
                            selectableClass=""
                            onFilterUpdate={ onParamsUpdate }
                            onReset={ onParamsReset }
                            rowRenderer={(user: UserList) => 
                                <UserListRow key={user.id} user={user} />
                            }
                        />                                        
                    </PageBody>
                </PageContent>;
};
